import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { LanguageProvider } from "@/lib/LanguageContext";
import AppLayout from "@/components/layout/AppLayout";
import Home from "@/pages/Home";
import BrowseJobs from "@/pages/BrowseJobs";
import JobDetail from "@/pages/JobDetail";
import PostJob from "@/pages/PostJob";
import Dashboard from "@/pages/Dashboard";
import MyJobs from "@/pages/MyJobs";
import DriverProfile from "@/pages/DriverProfile";
import EditProfile from "@/pages/EditProfile";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPayouts from "@/pages/AdminPayouts";
import AdminDisputes from "@/pages/AdminDisputes";
import AdminFinance from "@/pages/AdminFinance";
import AuthPage from "@/pages/AuthPage";
import Static from "@/pages/Static";
import FAQ from "@/pages/FAQ";
import BecomeDriver from "@/pages/BecomeDriver";
import Earnings from "@/pages/Earnings";
import MyPostings from "@/pages/MyPostings";
import "@/App.css";

const Protected = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center min-h-[60vh]"><div className="w-8 h-8 border-4 border-muted border-t-primary rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/jobs" element={<BrowseJobs />} />
        <Route path="/jobs/:id" element={<JobDetail />} />
        <Route path="/post" element={<Protected><PostJob /></Protected>} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/my-jobs" element={<Protected><MyJobs /></Protected>} />
        <Route path="/earnings" element={<Protected><Earnings /></Protected>} />
        <Route path="/my-postings" element={<Protected><MyPostings /></Protected>} />
        <Route path="/driver/:email" element={<DriverProfile />} />
        <Route path="/profile/edit" element={<Protected><EditProfile /></Protected>} />
        <Route path="/login" element={<AuthPage />} />
        <Route path="/register" element={<AuthPage mode="register" />} />
        <Route path="/admin" element={<Protected adminOnly><AdminDashboard /></Protected>} />
        <Route path="/admin/payouts" element={<Protected adminOnly><AdminPayouts /></Protected>} />
        <Route path="/admin/disputes" element={<Protected adminOnly><AdminDisputes /></Protected>} />
        <Route path="/admin/finance" element={<Protected adminOnly><AdminFinance /></Protected>} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/bliv-grabber" element={<Protected><BecomeDriver /></Protected>} />
        <Route path="/om-os" element={<Static page="about" />} />
        <Route path="/support" element={<Static page="support" />} />
        <Route path="/vilkaar" element={<Static page="terms" />} />
        <Route path="/privatliv" element={<Static page="privacy" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}
